export enum FeatureToggle {
  deliverySoftware = 'rt_delivery_software',
}
